export default [
  {
    path: '/perfil',
    component: () => import('@/modules/usuarios/views/pages/Profile.vue'),
    meta: {
      title: 'Notificações',
      breadcrumbs: [
        {
          name: 'Home',
          pathName: '/home',
        },
        {
          name: 'Notificações',
          pathName: null,
        },
      ],
    },
  },
  {
    path: '/usuarios',
    component: () => import('@/modules/usuarios/views/pages/Users.vue'),
    meta: {
      title: 'Usuários',
      pagePermission: 'usuarios/editar',
      allowOnlyMercapromo: true,
      breadcrumbs: [
        {
          name: 'Home',
          pathName: '/home',
        },
        {
          name: 'Usuários',
          pathName: null,
        },
      ],
    },
  },
  {
    path: '/usuarios/permissionamento/:email',
    component: () => import('@/modules/usuarios/views/pages/Permissions.vue'),
    meta: {
      title: 'Usuários',
      pagePermission: 'usuarios/permissionamento',
      allowOnlyMercapromo: true,
      breadcrumbs: [
        {
          name: 'Home',
          pathName: '/home',
        },
        {
          name: 'Usuários',
          pathName: '/usuarios',
        },
        {
          name: 'Permissionamento',
          pathName: null,
        },
      ],
    },
  },
]
